import ApiService from '../../../../../services/ApiService'
import InstitutionInactive from '../../../Institutions/components/institutionInactive/institutionInactive.vue'
import Utils from '../../../../../Utils/FormatDate'

export default {
  props: {
    title: String,
    alert: Object,
    newAlert: Boolean,
  },

  components: {
    InstitutionInactive,
  },

  created() {
    const institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = institution.id
    this.institutionInactive = institution.status == 1
    if (this.alert) {
      this.currentAlert = this.alert
      this.currentAlert.alertModule = this.alertsModule[this.alert.alertModule]
      this.status = this.alert.status === 1
      this.currentAlert.equipmentId =
        this.alert.equipmentId === 0 ? null : this.alert.equipmentId
      this.currentAlert.contractId =
        this.alert.contractId === 0 ? null : this.alert.contractId
      this.currentAlert.laborId =
        this.alert.laborId === 0 ? null : this.alert.laborId
      this.currentAlert.calibrationPatternId =
        this.alert.calibrationPatternId === 0
          ? null
          : this.alert.calibrationPatternId
      this.currentAlert.externalFileControlId =
        this.alert.externalFileControlId === 0
          ? null
          : this.alert.externalFileControlId

      if (this.alert.userId) {
        this.currentAlert.userId = this.alert.userId
      }

      this.eventDateTime = this.alert.eventDate
        ? this.alert.eventDate
        : this.alert.eventDateTime
      this.alertDateTime = this.alert.alertDateTime
      this.sendAlert = this.alert.sendAlert
      this.isEditing = !this.newAlert
    }
  },

  data: () => ({
    step: 0,
    selectedTab: 0,
    status: false,
    tab: null,
    errorMessage: '',
    menuEventDate: false,
    menuAlertDate: false,
    loading: false,
    firstValid: true,
    alterDialog: false,
    dialogKey: false,
    changedData: false,
    isEditing: false,
    error: false,
    institutionInactive: false,
    eventDateTimeError: false,
    alertDateTimeError: false,
    institutionId: null,
    eventDateTime: null,
    alertDateTime: null,
    alertsModule: [
      'OS',
      'Equipamento',
      'Contrato',
      'Tarefa',
      'Padrão calibração',
      'Arquivo externo controle',
      'Item',
    ],
    currentUser: {},
    currentAlert: {
      id: 0,
      description: '',
      eventDate: null,
      alertDate: null,
      alertModule: null,
      alertStatus: 0,
      equipmentId: null,
      contractId: null,
      laborId: null,
      unidadeId: null,
      userId: null,
      calibrationPatternId: null,
      externalFileControlId: null,
      sendAlert: false,
    },
    descriptionRules: [
      (v) => !!v || 'Descrição requerida',
      (v) =>
        (v && v.length <= 400) || 'Descrição deve ter no máximo 400 caracteres',
    ],
    moduleRules: [(v) => v != -1 || 'Módulo requerido'],
    apiService: new ApiService(),
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Dados gerais'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$emit('close')
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    converterStatusToInt(status) {
      if (status) {
        this.currentAlert.alertStatus = 1
      } else {
        this.currentAlert.alertStatus = 0
      }
    },

    setEventNowDate() {
      this.eventDateTime = !this.eventDateTime ? new Date() : this.eventDateTime
    },

    setAlertNowDate() {
      this.alertDateTime = !this.alertDateTime ? new Date() : this.alertDateTime
    },

    async next() {
      if (this.step === 0) {
        if (
          this.$refs.firstForm.validate() &&
          this.eventDateTime &&
          this.alertDateTime
        ) {
          this.submit()
        } else {
          this.eventDateTimeError = this.eventDateTime == null
          this.alertDateTimeError = this.alertDateTime == null
        }
      } else {
        if (this.$router.history.current.name == 'alert') {
          this.$router.push('/alert')
        }
        this.closeDialog()
      }
    },

    async submit() {
      this.loading = true

      if (!this.currentAlert.userId) {
        this.currentAlert.userId = JSON.parse(localStorage.getItem('user')).id
      }

      const alert = {
        Id: this.currentAlert.id,
        Description: this.currentAlert.description,
        EventDateTime: Utils.nowDatetimeFormat(this.eventDateTime),
        AlertDateTime: Utils.nowDatetimeFormat(this.alertDateTime),
        sendAlert: this.currentAlert.sendAlert,
        AlertModule: this.alertsModule.indexOf(this.currentAlert.alertModule),
        Status: this.currentAlert.alertStatus,
        UserId: this.currentAlert.userId,
        EquipmentId: this.currentAlert.equipmentId,
        ContractId: this.currentAlert.contractId,
        LaborId: this.currentAlert.laborId,
        InstitutionId: this.institutionId,
        UnidadeId: this.currentAlert.unidadeId,
        DepartmentId: this.currentAlert.departmentId,
        CalibrationPatternId: this.currentAlert.calibrationPatternId,
        ExternalFileControlId: this.currentAlert.externalFileControlId,
      }

      let url = 'alert/add'

      if (this.isEditing) {
        url = 'alert/edit'
      }

      await this.apiService
        .post(url, alert)
        .then(() => {
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.changedData = false
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },
  },

  watch: {
    currentAlert: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },

    eventDateTime: {
      deep: true,
      handler() {
        this.changedData = true
        this.eventDateTimeError = false
      },
    },

    alertDateTime: {
      deep: true,
      handler() {
        this.changedData = true
        this.alertDateTimeError = false
      },
    },
  },
}
